import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CreateActionComponent } from 'app/dialogs/create-action/create-action.component';
import { RequestTaskService } from 'app/services/models/request-task.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-company-detail-request-task-list',
  templateUrl: './company-detail-request-task-list.component.html',
  styleUrls: ['./company-detail-request-task-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CompanyDetailRequestTaskListComponent implements OnInit {
  @ViewChild('tableRowDetails') tableRowDetails: any;

  constructor(private requestTaskService: RequestTaskService, private activatedRouter: ActivatedRoute, private modalService: NgbModal) { }
  @BlockUI('section-block') blockUI: NgBlockUI;
  companyId = null;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;

  rowDetailsToggleExpand(row) {
    this.tableRowDetails.rowDetail.toggleExpandRow(row);
  }

  async ngOnInit() {
    this.activatedRouter.params.subscribe(params => {
      this.companyId = params['id'];
    })
    console.log(this.companyId);
    await this.getAllCompaniesPerson(this.pageBasic - 1, this.selectedSize, this.companyId);
  }



  async getAllCompaniesPerson(page, size, companyId) {
    this.blockUI.start()
    try {
      const data = await this.requestTaskService.getAllRequestTaskCompaines(page, size, companyId);
      this.rows = data.requestTasks;
      console.log(data);
      this.totalCount = data.totalCount;
    } catch (error) {
    }
    this.blockUI.stop()
  }

  async onPageChange(pageNumber: number) {
    await this.getAllCompaniesPerson(this.pageBasic - 1, this.selectedSize, this.companyId);
  }
  async onOptionChange() {

    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllCompaniesPerson(this.pageBasic - 1, this.selectedSize, this.companyId);
  }

  getRowHeight(row: any): number {
    return row?.actions.length * 20; // Her bir action için 20 piksel
  }

  showCrateAksiyon(item) {
    const modal = this.modalService.open(CreateActionComponent, {
      size: 'lg',
    });
    modal.componentInstance.data = {
      requestTask: item,
      actionId: null
    }
  }
}
